module.exports = __webpack_public_path__ + "static/img/planning3.7d39b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/planning3.png
// module id = DIOV
// module chunks = 1